export const links = {
    dashbord: "https://dashboard-ping-proxies.goodface.com.ua/",
}